import { Injectable } from "../di/decorators.js";
function Module(metadata) {
    return function(target) {
        Injectable(target);
        target.prototype.metadata = metadata;
        return target;
    };
}
function createModule(metadata) {
    return Module(metadata);
}
export { Module, createModule };
